import { createReducer, on } from '@ngrx/store'
import {
  login,
  loginFailure,
  loginSuccess,
  logout,
} from './authentication.actions'
import type { User } from './auth.model'

export type AuthenticationState = {
  isLoggedIn: boolean
  user: User | null
  error: any | null
}

const initialState: AuthenticationState = {
  isLoggedIn: false,
  user: null,
  error: null,
}

export const authenticationReducer = createReducer(
  initialState,
  on(login, (state) => {
     ; // Debug here when login is dispatched
    return { ...state, error: null };
  }),
  on(loginSuccess, (state, { user }) => {
     ; // Debug here when loginSuccess is dispatched
    return {
      ...state,
      isLoggedIn: true,
      user,
      error: null,
    };
  }),
  on(loginFailure, (state, { error }) => {
     ; // Debug here when loginFailure is dispatched
    return { ...state, error };
  }),
  on(logout, (state) => {
     ; // Debug here when logout is dispatched
    return { ...state, user: null };
  })
)
